(() => {
  'use strict';

  const COMPONENT_NAME = 'product-inquiry';

  if (customElements.get(COMPONENT_NAME)) return;

  // Prodotto "a richiesta": form di prenotazione aperto a chiunque, anche non
  // loggato. Nessun challenge, nessun login, nessun reload: si apre il modulo,
  // si inviano i dati di contatto e si mostra l'esito. La protezione dai bot
  // (honeypot + rate-limit) e' lato PIM.
  class ProductInquiry extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.openButton = this.querySelector('[data-inquiry-open]');
      this.form = this.querySelector('[data-inquiry-form]');
      this.status = this.querySelector('[data-inquiry-status]');
      this.submitButton = this.querySelector('[data-inquiry-submit]');

      if (!this.form || !this.openButton) return;

      this.openButton.addEventListener('click', () => this.showForm());
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    showForm() {
      this.form.hidden = false;
      this.openButton.setAttribute('aria-expanded', 'true');
      this.form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    showStatus(message, isError = false) {
      if (!this.status) return;
      this.status.textContent = message || '';
      this.status.hidden = !message;
      this.status.classList.toggle('product-inquiry__status--error', isError);
      this.status.classList.toggle('product-inquiry__status--success', !isError);
    }

    setBusy(busy) {
      this.toggleAttribute('aria-busy', busy);
      this.openButton.disabled = busy;
      this.submitButton.disabled = busy;
      this.submitButton.textContent = busy ? 'Invio in corso…' : 'Invia richiesta';
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.form.reportValidity()) return;

      const apiUrl = this.form.dataset.apiUrl;
      if (!apiUrl) {
        this.showStatus('Endpoint PIM non configurato.', true);
        return;
      }

      this.setBusy(true);
      this.showStatus('');
      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            Accept: 'application/json',
          },
          body: new URLSearchParams(new FormData(this.form)),
        });
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          const firstError = data.errors
            ? Object.values(data.errors)[0]
            : data.error;
          throw new Error(firstError || 'Impossibile inviare la richiesta.');
        }

        this.showStatus(
          `Richiesta ${data.reference} registrata. Ti contatteremo dopo la verifica per concordare disponibilità, prezzo, consegna e pagamento.`
        );
        this.toggleAttribute('aria-busy', false);
        this.submitButton.textContent = 'Richiesta inviata';
        this.form.querySelectorAll('input, select, textarea, button')
          .forEach((element) => {
            element.disabled = true;
          });
      } catch (error) {
        this.showStatus(error.message, true);
        this.setBusy(false);
      }
    }
  }

  customElements.define(COMPONENT_NAME, ProductInquiry);
})();
